import { useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import { Button, Card, Space, Table, Tag, notification } from 'antd';
import { PageTemplate } from '@/shared/ui/templates';
import { DiContainer } from '@@/di/di-container';
import { DlpService } from '../../services/dlp.service';
import {
  $consents,
  $mySegments,
  fetchConsentsFx,
  fetchMySegmentsFx,
} from '../../store/dlp.store';
import { ConsentItem } from '../../ts';

const PARAM_NAME: Record<string, string> = {
  '1': 'Клейковина',
  '2': 'Влажность',
  '3': 'ИДК',
  '4': 'ЧП',
  '5': 'Протеин',
  '6': 'Натура',
};

export const DlpGrainPage = () => {
  const svc = () => DiContainer.get(DlpService);
  const segments = useStore($mySegments);
  const consents = useStore($consents);
  const [loading, setLoading] = useState(false);

  const reload = () => {
    fetchMySegmentsFx();
    fetchConsentsFx();
  };
  useEffect(() => {
    reload();
  }, []);

  const decide = async (item: ConsentItem, decision: 'approved' | 'rejected') => {
    setLoading(true);
    try {
      await svc().consent(item.id, decision);
      notification.success({ message: decision === 'approved' ? 'Согласовано' : 'Отклонено' });
      reload();
    } catch (e: any) {
      notification.error({ message: e?.error || e?.message || 'Ошибка' });
    } finally {
      setLoading(false);
    }
  };

  const segColumns = [
    { title: 'Рукав', dataIndex: 'bag_id', key: 'bag_id' },
    { title: 'Склад', dataIndex: 'warehouse_id', key: 'warehouse_id' },
    { title: 'Вес', dataIndex: 'weight', key: 'weight' },
    { title: 'Бронь', dataIndex: 'reserved_weight', key: 'reserved_weight' },
    { title: 'Доступно', dataIndex: 'available_weight', key: 'available_weight' },
    {
      title: 'Качество (при закладке)',
      key: 'q',
      render: (_: any, s: any) =>
        Object.entries(s.quality_at_loading || {})
          .filter(([k]) => PARAM_NAME[k])
          .map(([k, v]) => `${PARAM_NAME[k]}: ${v}`)
          .join(', '),
    },
  ];

  const consentColumns = [
    { title: 'Партия', key: 'code', render: (_: any, i: ConsentItem) => i.lot?.code || i.digital_lot_id },
    { title: 'Рукав', key: 'bag', render: (_: any, i: ConsentItem) => i.segment?.bag_id },
    { title: 'Вес', dataIndex: 'weight', key: 'weight' },
    { title: 'Цена', dataIndex: 'price', key: 'price' },
    {
      title: 'Статус',
      dataIndex: 'consent_status',
      key: 'consent_status',
      render: (s: string) => <Tag color={s === 'pending' ? 'processing' : s === 'approved' ? 'green' : 'red'}>{s}</Tag>,
    },
    {
      title: 'Действие',
      key: 'actions',
      render: (_: any, i: ConsentItem) => (
        <Space>
          <Button size="small" type="primary" onClick={() => decide(i, 'approved')}>
            Согласиться
          </Button>
          <Button size="small" danger onClick={() => decide(i, 'rejected')}>
            Отклонить
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <PageTemplate header="Моё зерно">
      <div style={{ padding: 16 }}>
        <Card title="Заявки на продажу моего зерна" style={{ marginBottom: 16 }}>
          <Table rowKey="id" loading={loading} columns={consentColumns} dataSource={consents} pagination={false} />
        </Card>
        <Card title="Мои рукава (сегменты)">
          <Table rowKey="id" columns={segColumns} dataSource={segments} pagination={{ pageSize: 20 }} />
        </Card>
      </div>
    </PageTemplate>
  );
};
